import { I18n } from '@calendly/i18n'
import { useMemo } from 'react'

import { useETEditorFormikPoolingType } from 'services/event_types'

import { getIsAnyCollectiveUserPools } from '../utils'

export const usePropsForInline = (kind, eventType, userPools, locations) => {
  const { isRoundRobin, isCollectiveRoundRobin } = useETEditorFormikPoolingType()
  const { isGroup, isPoll } = eventType

  return useMemo(() => {
    const isAnyCollectiveUserPools = getIsAnyCollectiveUserPools(userPools)
    let tooltipText

    if (isRoundRobin || (isCollectiveRoundRobin && !isAnyCollectiveUserPools)) {
      tooltipText = I18n.t('publisher.event_types.location.round_robin_disabled_call_tooltip')
    } else if (isGroup) {
      tooltipText = I18n.t('publisher.event_types.location.group_disabled_call_tooltip')
    } else if (isPoll) {
      tooltipText = I18n.t('publisher.event_types.location.meeting_poll_disabled_call_tooltip')
    }

    const hasMultipleLocations = locations?.length > 1
    const canHideLocation = !isRoundRobin
      && !(isCollectiveRoundRobin && !isAnyCollectiveUserPools)
      && !hasMultipleLocations

    return {
      kind,
      tooltipText,
      canHideLocation
    }
  }, [userPools, isRoundRobin, isCollectiveRoundRobin, isGroup, isPoll, locations?.length, kind])
}
